import type { AxiosResponse } from 'axios'
import Request from './config'
import { getWebX7syDev } from '@/utils/headers'
import _localStorage from '@/utils/storage'
import { getFetchBaseURL } from './utils'

const request: any = new Request({
  baseURL: getFetchBaseURL(),
  timeout: 120000, // 请求超时时间
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  interceptors: {
    // 请求拦截器
    requestInterceptors: (config) => {
      config.headers['Web-X7sy-Dev'] = getWebX7syDev() // web请求标识
      config.headers['X7-Debug-Token'] = _localStorage.get('X7-Debug-Token') || ''
      if (import.meta.env.VITE_X7_REQ_ENV) {
        config.headers['X7-Req-Env'] = import.meta.env.VITE_X7_REQ_ENV
        config.headers['X7-Req-Hash'] = '0e188196e2ab6e9b3a8f22873ebc0778' // 目前是固定写死的
      } else {
        delete config.headers['X7-Req-Env']
        delete config.headers['X7-Req-Hash']
      }
      return config
    },
    // 响应拦截器
    responseInterceptors: <T extends AxiosResponse>(result: T): T => {
      return result
    },
    responseInterceptorsCatch: (error: any) => {
      MessagePlugin('error', error?.msg || error?.message || '请求失败，请稍后重试')
      console.log('error', error)
      const data = error?.response?.data ? error.response?.data : error
      console.log('data', data)
      // MessagePlugin('error', data?.msg || '请求失败，请稍后重试')
      return Promise.reject(data)
    }
  }
})

export default request.instance
